import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';

import { useLocation } from 'react-router-dom';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const PayUTransaction = () => {
    const formRef = useRef(null);
    const location = useLocation();
    const Hash = location.state.Hash;
    const OrderID = location.state.OrderID;
    const Key = location.state.Key;
    const Amount = location.state.Amount;
    const Name = location.state.Name;
    const Email = location.state.Email;
    const SuccessURL = location.state.SuccessURL;
    const FailURL = location.state.FailURL;
    const ActionURL = location.state.ActionURL;
    const ContactNumber = location.state.ContactNumber;
    const Currency = location.state.Currency;

    const initialValues = {
        Hash: Hash,
        OrderID: OrderID,
        Key: Key,
        Amount: Amount,
        Name: Name,
        Email: Email,
        ContactNumber: ContactNumber,
        SuccessURL: SuccessURL,
        ActionURL: ActionURL,
        FailURL: FailURL,
        Currency: Currency
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        formRef.current.submit();
    }, []);
    return (
        <CustomContainer>
            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.ActionURL}
            >
                <input type="hidden" name="key" value={FormObj.Key} />
                <input type="hidden" name="txnid" value={FormObj.OrderID} />
                <input
                    type="hidden"
                    name="productinfo"
                    value={FormObj.Currency}
                />
                <input type="hidden" name="amount" value={FormObj.Amount} />
                <input type="hidden" name="email" value={FormObj.Email} />
                <input
                    type="hidden"
                    name="phone"
                    value={FormObj.ContactNumber}
                />
                <input type="hidden" name="firstname" value={FormObj.Name} />
                <input type="hidden" name="surl" value={FormObj.SuccessURL} />
                <input type="hidden" name="furl" value={FormObj.FailURL} />
                <input type="hidden" name="hash" value={FormObj.Hash} />
                <input type="submit" value="Redirect" />
            </form>
        </CustomContainer>
    );
};
